import { gql } from '@apollo/client';

/**
 * GraphQL mutation to create a standard policy
 */
export const CREATE_STANDARD_POLICY = gql`
  mutation CreateStandardPolicy($input: CreateStandardPolicyInput!) {
    createStandardPolicy(input: $input) {
      id
      communityId
      name
      description
      isEnabled
      labels {
        labelId
        severity
        scoreThreshold
      }
      createdBy
      createdAt
      lastModifiedBy
      lastModifiedAt
      scope
      isSystemManaged
      sourcePolicyId
    }
  }
`;
